<app-template-password
  [disabled]="disabled"
  [required]="required"
  [characters]="characters"
  [value]="value"
  [control]="control"
  [minlength]="minlength"
  [maxlength]="maxlength"
  [label]="label"
/>
